import React from 'react';
import MuiButton from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const VARIANT_MAP = {
  primary: { variant: 'contained', color: 'primary' },
  secondary: { variant: 'contained', color: 'secondary' },
  outlined: { variant: 'outlined', color: 'primary' },
  ghost: { variant: 'text', color: 'primary' },
  danger: { variant: 'contained', color: 'error' },
  'danger-outlined': { variant: 'outlined', color: 'error' },
};

/**
 * App-standard button. Wraps MUI Button with consistent variants and loading state.
 */
export default function Button({
  variant = 'primary',
  size = 'medium',
  loading = false,
  disabled = false,
  startIcon,
  endIcon,
  children,
  sx,
  ...rest
}) {
  const mapped = VARIANT_MAP[variant] || VARIANT_MAP.primary;
  const isDisabled = disabled || loading;

  return (
    <MuiButton
      variant={mapped.variant}
      color={mapped.color}
      size={size}
      disabled={isDisabled}
      startIcon={
        loading ? (
          <CircularProgress size={size === 'small' ? 14 : 16} color="inherit" />
        ) : (
          startIcon
        )
      }
      endIcon={loading ? undefined : endIcon}
      sx={{
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 'var(--radius-sm)',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MuiButton>
  );
}
